const typography = {
  h1: {
    fontSize: "96px",
    fontFamily: "League Spartan, sans-serif",
    fontWeight: 700,
    letterSpacing: "-1.5px",
    lineHeight: "116.7%",
  },
  h2: {
    fontSize: "60px",
    fontFamily: "League Spartan, sans-serif",
    fontWeight: 600,
    letterSpacing: "-0.5px",
    lineHeight: "120%",
  },
  h3: {
    fontSize: "48px",
    fontFamily: "Space Grotesk, sans-serif",
    fontWeight: 700,
    letterSpacing: "0px",
    lineHeight: "116.7%",
  },
  h4: {
    fontSize: "34px",
    fontFamily: "Space Grotesk, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.25px",
    lineHeight: "123.5%",
  },
  h5: {
    fontSize: "26px",
    fontFamily: "Space Grotesk, sans-serif",
    fontWeight: 400,
    letterSpacing: "0px",
    lineHeight: "133.4%",
  },
  h6: {
    fontSize: "22px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.15px",
    lineHeight: "160%",
  },
  body1: {
    fontSize: "18px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.15px",
    lineHeight: "150%",
  },
  body2: {
    fontSize: "16px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.17px",
    lineHeight: "143%",
  },
  subtitle1: {
    fontSize: "18px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 700,
    letterSpacing: "0.15px",
    lineHeight: "175%",
  },
  subtitle2: {
    fontSize: "16px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.1px",
    lineHeight: "157%",
  },
  overline: {
    fontSize: "16px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    letterSpacing: "1px",
    lineHeight: "150%",
  },
  caption: {
    fontSize: "14px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "166%",
  },
  alertTitle: {
    fontSize: "16px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.15px",
    lineHeight: "150%",
  },
  alertDescription: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.15px",
    lineHeight: "143%",
  },
  avatarInitials: {
    fontSize: "20px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.14px",
    lineHeight: "20px",
  },
  badgeLabel: {
    fontSize: "12px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 600,
    letterSpacing: "0.14px",
    lineHeight: "20px",
  },
  bottomNavigationActiveLabel: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "166%",
  },
  buttonLarge: {
    fontSize: "15px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.46px",
    lineHeight: "26px",
  },
  buttonMedium: {
    fontSize: "14px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.4px",
    lineHeight: "24px",
  },
  buttonSmall: {
    fontSize: "12px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.46px",
    lineHeight: "16px",
  },
  chipLabel: {
    fontSize: "13px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.16px",
    lineHeight: "18px",
  },
  datePickerCurrentMonth: {
    fontSize: "16px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.15px",
    lineHeight: "150%",
  },
  inputLabel: {
    fontSize: "12px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.15px",
    lineHeight: "12px",
  },
  inputValue: {
    fontSize: "16px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.15px",
    lineHeight: "24px",
  },
  inputHelper: {
    fontSize: "12px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "166%",
  },
  listSubheader: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.1px",
    lineHeight: "48px",
  },
  menuItemDefault: {
    fontSize: "16px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.15px",
    lineHeight: "150%",
  },
  menuItemDense: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    letterSpacing: "0.17px",
    lineHeight: "24px",
  },
  tableHeader: {
    fontSize: "14px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.17px",
    lineHeight: "24px",
  },
  tooltipLabel: {
    fontSize: "10px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0px",
    lineHeight: "14px",
  },
  dataGridAggregationColumnHeaderLabel: {
    fontSize: "12px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    letterSpacing: "0.15px",
    lineHeight: "12px",
  },
  libraryHeading: {
    fontSize: "64px",
    fontFamily: "Roboto Mono, sans-serif",
    fontWeight: 500,
    letterSpacing: "-1.5px",
    lineHeight: "116.7%",
  },
};

export default typography;
